// eslint-disable-next-line no-undef
export const API_URL = `${window.BPS.API_URL}/api`;
